import React from 'react';

import { useMainMenuContext } from 'state/menu/main-menu';
import { useUIContext } from 'state/ui';

interface IFormatMenuPriceProps {
  menuItemId: string;
}

const FormatMenuPrice: React.FC<React.PropsWithChildren<IFormatMenuPriceProps>> = ({
  menuItemId,
}) => {
  const { getPricingAndAvailability } = useMainMenuContext();
  const { formatCurrencyForLocale } = useUIContext();

  if (!menuItemId) {
    return null;
  }

  const pricingAndAvailability = getPricingAndAvailability(menuItemId);

  if (!pricingAndAvailability) {
    return null;
  }

  const { price } = pricingAndAvailability;

  if (price?.default) {
    return <>{formatCurrencyForLocale(price.default)}</>;
  }

  if (!price?.default && price?.min) {
    return <>{formatCurrencyForLocale(price.min)}</>;
  }

  return null;
};

export default FormatMenuPrice;
